import { Box } from '@mui/material';

const DOT_SX = {
  width: 8,
  height: 8,
  borderRadius: 999,
  flexShrink: 0,
  '@keyframes interruptionPulse': {
    '0%, 100%': { opacity: 1 },
    '50%': { opacity: 0.35 },
  },
  animation: 'interruptionPulse 1.6s ease-in-out infinite',
} as const;

const getDotSx = (color: string) => ({
  ...DOT_SX,
  backgroundColor: color,
});

type InterruptionTypeDotProps = {
  color: string;
};

const InterruptionTypeDot = ({ color }: InterruptionTypeDotProps) => <Box component="span" sx={getDotSx(color)} />;

export default InterruptionTypeDot;
